import AbilityScoreManagerStandardArray from "./AbilityScoreManagerStandardArray";

export default AbilityScoreManagerStandardArray;
export { AbilityScoreManagerStandardArray };
